import { render, staticRenderFns } from "./ProfileFormSkeleton.vue?vue&type=template&id=e615927e&scoped=true&"
import script from "./ProfileFormSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProfileFormSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFormSkeleton.vue?vue&type=style&index=0&id=e615927e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e615927e",
  null
  
)

export default component.exports